import { useEffect, useState, useContext, Fragment, useRef } from "react";
import { Box } from "@mui/material";
import {
  ObserveSaleOrderLineBySaleOrder,
  deleteSaleOrderLineById,
  deleteAllSaleOrderLineById,
} from "../../../../database/helpers/sale_order_line";
import {
  getSaleOrderByIdObserve,
  deleteSaleOrderById,
} from "./../../../../database/helpers/sale_order";
import { updateStockSellPrice } from "./../../../../database/helpers/stock";
import { getCustomersByBusiness } from "../../../../database/helpers/customer";
import withObservables from "@nozbe/with-observables";
import { LanguageContext } from "../../../../context/LanguageContext";
import { HeadingText, ParagraphText, UBButton } from "../../../../Libraries";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import {
  NetCalculationCard,
  TwoColumnWrapperHeader,
  twoColumnWrapperHeaderStyles,
  SaleItemRow,
  DiscountAndTax,
} from "./../../../common";
import AddCustomerModal from "../../../common/Modals/AddCustomerModal";
import { phoneNumRegex } from "../../../../validations";
import { ReactComponent as NonIdealSalebook } from "../../../../assets/icons/nonIdealSalebook.svg";
import { ReactComponent as AccountIcon } from "../../../../assets/icons/add-customer.svg";
import { DRAFT, sentenceCase } from "./../../../../constants";
import styles from "./styles.module.css";
import { SaleBookNonIdeal } from "../../../common/NewNonIdeal";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import useOrderSummary from "../../../../hooks/useOrderSummary";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { useNavigate } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { AddContactIcon } from "../../../../assets/icons/icon";
import { getInitials } from "../../../../utils";
import NonIdealNew from "../../../common/NonIdealNew";

const SaleOrderLineItem = ({
  sale_order_line,
  setCustomer = () => {},
  selectedCustomer,
  sale_order,
  business,
  user,
  onDraftSaved = () => {},
}) => {
  const [totalDiscount, setTotalDiscount] = useState({
    edit: false,
    value: 0,
    type: "rs",
  });
  const [totalTax, setTotalTax] = useState({
    edit: false,
    value: 0,
    type: "%",
  });
  const [selectedOrder, setSelectedOrder] = useState();
  const [activeSaleOrder, setActiveSaleOrder] = useState();
  const [error, setError] = useState({});
  const [draftModal, setDraftModal] = useState(false);
  const [clearAllConfirmOpen, setClearAllConfirmOpen] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [addContact, setAddContact] = useState(false);
  const [createCustomerModal, setCreateCustomerModal] = useState(false);
  const [initName, setInitname] = useState("");
  const [initPhone, setInitphone] = useState("");
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const prevLengthRef = useRef(sale_order_line.length);
  useEffect(() => {
    const currentLength = sale_order_line.length;

    // Compare current and previous length
    if (currentLength > prevLengthRef.current) {
      // Scroll to the bottom if current length is greater
      if (containerRef.current) {
        containerRef.current.scrollTop = containerRef.current.scrollHeight;
      }
    }

    // Update the previous length to the current one
    prevLengthRef.current = currentLength;
  }, [sale_order_line]); // Trigger the effect whenever sale_order_line changes

  const {
    subTotalAmount,
    totalAmount,
    calculateOrderSummary,
    totalDiscountPerItem,
  } = useOrderSummary({
    sale_order_line,
    orderDiscount: activeSaleOrder?._raw?.discount,
    orderDiscountMethod: activeSaleOrder?._raw?.discount_unit,
    orderTax: activeSaleOrder?._raw?.tax,
    orderTaxMethod: activeSaleOrder?._raw?.tax_type,
  });

  useEffect(() => {
    if (sale_order.length) {
      setActiveSaleOrder(sale_order[0]);
      setError({});
      const saleOrder = sale_order[0];
      setTotalDiscount({
        edit: !!saleOrder._raw.discount,
        type: saleOrder._raw?.discount_unit,
        value: saleOrder._raw.discount,
      });
      setTotalTax({
        edit: !!saleOrder._raw.tax,
        type: saleOrder._raw?.tax_type,
        value: saleOrder._raw.tax,
      });
    }
  }, [sale_order]);

  useEffect(() => {
    if (totalAmount < 0) {
      handleTotalDiscount({ value: 0, valueMethod: "rs" });
    }
  }, [totalAmount]);
  const handleTotalDiscount = async (payload) => {
    try {
      activeSaleOrder.status === "active" &&
        (await activeSaleOrder.updateSaleOrderDiscount({
          discount: payload.value,
          discount_unit: payload.valueMethod,
        }));
    } catch (error) {
    }
  };

  const handleTotalTax = async (payload) => {
    try {
      await activeSaleOrder.updateSaleOrderTax({
        tax: payload.value,
        tax_type: "%",
      });
    } catch (error) {
    }
  };

  const itemDiscount = (item) => {
    setSelectedOrder(item);
  };
  const removeItem = async (item) => {
    try {
      await deleteSaleOrderLineById(item.id);
      triggerLogEvent(analytics, "pos_item_removed");
      if (sale_order_line.length === 1) {
        resetTaxAndDiscount();
      }
    } catch (error) {
    }
  };

  const resetTaxAndDiscount = () => {
    handleTotalDiscount({ discount: null, discount_unit: "rs" });
    handleTotalTax({ tax: null, tax_type: "%" });
  };
  const onUpdateSaleOrderline = async (item, updatedVal, key) => {
    try {
      switch (key) {
        case "name":
          await item.updateName(updatedVal);
          break;
        case "quantity":
          await item.updateQuantity(updatedVal);
          break;
        case "selling_price":
          await item.updateSellingPrice(updatedVal);
          break;
      }
      setSelectedOrder(null);
      if (
        item.discount_method === "rs" &&
        item.discount > item?.selling_price
      ) {
        onUpdateDiscountSaleOrderline(item, { value: 0, valueMethod: "rs" });
      }
    } catch (error) {
    }
  };
  const onUpdateDiscountSaleOrderline = async (item, payload) => {
    try {
      await item.updateDiscount(payload.value);
      await item.updateDiscountMethod(payload.valueMethod);
      setSelectedOrder(null);
      calculateOrderSummary();
      triggerLogEvent(analytics, "pos_item_discount");
    } catch (error) {
    }
  };

  const clearAllItem = async () => {
    try {
      await deleteAllSaleOrderLineById(activeSaleOrder?.id);
      resetTaxAndDiscount();
      setError({});
      triggerLogEvent(analytics, "pos_clear_items", {});
    } catch (error) {
    }
  };

  const handleConfirmClearAll = async () => {
    setClearAllConfirmOpen(false);
    await clearAllItem();
  };

  const saveOrderInDraft = async () => {
    try {
      await activeSaleOrder.updateSaleOrderStatus(DRAFT);
      await business?.createSaleOrder({
        status: "active",
      });
      setDraftModal(false);
      setError({});
      triggerLogEvent(analytics, "pos_new_sales");
      triggerLogEvent(analytics, "pos_draft_sale_created");
      onDraftSaved();
    } catch (error) {
    }
  };
  const discardOrder = async () => {
    try {
      await deleteAllSaleOrderLineById(activeSaleOrder?.id);
      await deleteSaleOrderById(activeSaleOrder?.id);
      await business?.createSaleOrder({
        status: "active",
      });
      setDraftModal(false);
      setError({});
      triggerLogEvent(analytics, "pos_new_sales");
    } catch (error) {
    }
  };

  const handleDraftModalClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKey") {
      setDraftModal(false);
      return;
    }
    discardOrder();
  };

  const onUpdateStockPrice = async (item, price) => {
    try {
      await updateStockSellPrice(item?._raw?.stock_id, price);
    } catch (error) {
    }
  };

  useEffect(() => {
    const businessId = activeSaleOrder?._raw?.business_id;
    if (!businessId) return;
    getCustomersByBusiness(businessId).then((customers) => {
      setContactList(
        customers.map((c) => ({
          id: c.id,
          label: c._raw?.name || "",
          value: c._raw?.name || "",
        })),
      );
    });
  }, [activeSaleOrder?._raw?.business_id]);

  const openCreateCustomerModal = (value) => {
    if (value?.match?.(phoneNumRegex) === null) {
      setInitname(value);
      setInitphone("");
    } else {
      setInitphone(value);
      setInitname("");
    }
    setCreateCustomerModal(true);
  };

  const handleAddCustomer = (payload) => {
    setCreateCustomerModal(false);
    setCustomer(payload ?? null);
    if (payload?.id) triggerLogEvent(analytics, "pos_customer_added_with_sale");
  };

  const checkOut = () => {
    triggerLogEvent(analytics, "pos_checkout");
    navigate(`/SaleBook/OrderSummary`, { state: { totalAmount: totalAmount } });
  };
  const formattedCount =
    sale_order_line.length < 10
      ? `0${sale_order_line.length || ""}`
      : sale_order_line.length;

  const handleGetError = (err) => {
    const updatedError = { ...error };
    if (err.error) {
      updatedError[err.from] = err.error;
    } else {
      delete updatedError[err.from];
    }
    setError(updatedError);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      const activeElement = document.activeElement;
      const tagName = activeElement.tagName.toLowerCase();
      const className = activeElement.className;
      const isContentEditable = activeElement.isContentEditable;
      if (
        (tagName === "input" || tagName === "textarea" || isContentEditable) &&
        !className.includes("sale-rupees-input")
      ) {
        return;
      }
      // shift + N to create new sale
      if (
        event.shiftKey &&
        event.key.toLowerCase() === "n" &&
        sale_order_line?.length > 0
      ) {
        event.preventDefault();
        setDraftModal(true);
      }
      if (
        event.shiftKey &&
        event.key === "Enter" &&
        !(Object.keys(error).length > 0) &&
        sale_order_line.length > 0
      ) {
        event.preventDefault();
        checkOut();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [error, sale_order_line]);

  return (
    <Box className={styles.lineItemContainer}>
      <TwoColumnWrapperHeader>
        <Box className={twoColumnWrapperHeaderStyles.left}>
          <HeadingText className={"fontSize18 fontWeight500 newFontColor"}>
            {I18n.current_sale} ({formattedCount})
          </HeadingText>
        </Box>
        <Box className={twoColumnWrapperHeaderStyles.right}>
          {sale_order_line?.length > 0 ? (
            <Fragment>
              <TabAutoComplete
                id="quick_contactlist"
                list={contactList}
                className={styles.customerSearch}
                hideSuffixIcon
                prefixIcon={
                  <Box className={styles.prefixContainer}>
                    {selectedCustomer?.name ? (
                      <ParagraphText className={styles.contactName}>
                        {getInitials(selectedCustomer.name)}
                      </ParagraphText>
                    ) : (
                      <AddContactIcon width={12} height={12} />
                    )}
                  </Box>
                }
                handleSelect={(item) => {
                  const customer = item
                    ? { id: item.id, name: item.label }
                    : null;
                  setCustomer(customer);
                  if (item?.id)
                    triggerLogEvent(analytics, "pos_customer_added_with_sale");
                }}
                value={selectedCustomer?.name || ""}
                handleCreate={openCreateCustomerModal}
                asCreate = {"contact"}
                placeholder={I18n.add_contact}
                handleStartLogEvent={() =>
                  triggerLogEvent(analytics, "pos_customer_start")
                }
                manuallyFocusInput={addContact}
                handleManuallyInput={() => setAddContact(false)}
              />

              <UBButton
                id={"clear_item"}
                title={I18n.clear_item}
                className={styles.clearAllBtn}
                onClick={() => setClearAllConfirmOpen(true)}
                disabled={!(sale_order_line.length > 0)}
              />
            </Fragment>
          ) : null}
        </Box>
      </TwoColumnWrapperHeader>
      {sale_order_line?.length > 0 ? (
        <Box className={styles.saleOrderItemContainer} flex={1}>
          <Box
            ref={containerRef}
            className={`${styles.saleOrderItem} generic-scrollbar`}
          >
            {sale_order_line.map((item) => {
              const DEFAULT_MENU_OPTION = [
                { label: I18n.item_discount || "Item discount", action: () => itemDiscount(item) },
                { label: I18n.remove_item || "Remove item", action: () => removeItem(item) },
              ];
              return (
                <Box className={`${styles.saleItemRow} saleItemRow`} key={item?.id}>
                  <SaleItemRow
                    onUpdate={onUpdateSaleOrderline}
                    item={item}
                    actionMenuOptions={DEFAULT_MENU_OPTION}
                    onUpdateStockPrice={(price) =>
                      onUpdateStockPrice(item, price)
                    }
                    onDelete={removeItem}
                  />
                  <DiscountAndTax
                    item={item._raw}
                    onUpdate={(payload) =>
                      onUpdateDiscountSaleOrderline(item, payload)
                    }
                    handleLogEvent={() =>
                      triggerLogEvent(analytics, "pos_item_dic_start")
                    }
                    value={selectedOrder?._raw?.discount}
                    valueMethod={selectedOrder?._raw?.discount_method}
                    totalAmount={selectedOrder?._raw?.selling_price}
                    className={styles.discountAndTax}
                    open={selectedOrder?.id === item?.id}
                  />
                </Box>
              );
            })}
          </Box>

          <div className={styles.actionWrapper}>
            <NetCalculationCard
              subTotalAmt={subTotalAmount - totalDiscountPerItem}
              totalDiscount={totalDiscount}
              setTotalDiscount={setTotalDiscount}
              handleTotalDiscount={handleTotalDiscount}
              totalTax={totalTax}
              setTotalTax={setTotalTax}
              handleTotalTax={handleTotalTax}
              totalAmount={subTotalAmount - totalDiscountPerItem}
              handleGetError={handleGetError}
              handleDiscountLogEvent={() =>
                triggerLogEvent(analytics, "pos_disc_start")
              }
              handleTaxLogEvent={() =>
                triggerLogEvent(analytics, "pos_tax_start")
              }
            />
            <Box
              className={styles.checkoutActions}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap={2}
            >
              <UBButton
                id={"new_sale_id"}
                title={I18n.new_sale}
                className={`newFontColor buttonTeritary ${styles.newsale} fontSize14`}
                onClick={() => setDraftModal(true)}
              />
              <UBButton
                id={"checkout_id"}
                title={`${I18n.checkout} (Rs. ${formatNum(totalAmount)})`}
                className={`newFontColor ${styles.checkout} fontSize14`}
                onClick={checkOut}
                disabled={Object.keys(error).length > 0}
              />
            </Box>
          </div>
        </Box>
      ) : (
        <NonIdealNew
          title={I18n.sale_items}
          subtitle={I18n.item_non_ideal_desc}
          customClassName={styles.nonIdealOrderLine}
        />
      )}

      <ConfirmationModal
        id="sale_pos_draft"
        open={draftModal}
        onClose={handleDraftModalClose}
        message={I18n.draft_message}
        title={I18n.this_action_cannot_be_undone}
        cancelText={I18n.discard}
        confirmText={I18n.confirm}
        confirmButtonClassName="ubPrimaryButton"
        onConfirm={saveOrderInDraft}
      />

      <ConfirmationModal
        id="sale_pos_clear_all"
        open={clearAllConfirmOpen}
        onClose={() => setClearAllConfirmOpen(false)}
        message={I18n.pos_clear_all_items_body}
        title={I18n.this_action_cannot_be_undone}
        confirmText={I18n.clear_all_items}
        confirmButtonClassName="ubPrimaryButton"
        onConfirm={handleConfirmClearAll}
      />

      <AddCustomerModal
        isOpen={createCustomerModal}
        handleClose={() => setCreateCustomerModal(false)}
        initialName={initName}
        initialPhone={initPhone}
        onSaveCallback={handleAddCustomer}
        type="in"
        isTypeField={false}
      />
    </Box>
  );
};

const enhance = withObservables(
  ["activeSaleOrder", "sale_order_line", "sale_order"],
  ({ activeSaleOrder }) => {
    return {
      sale_order_line: ObserveSaleOrderLineBySaleOrder(
        activeSaleOrder?.id ?? "",
      ),
      sale_order: getSaleOrderByIdObserve(activeSaleOrder?.id ?? ""),
    };
  },
);

export default enhance(SaleOrderLineItem);
